import type { TemplateFn } from "./index";
import { ROOT_TARGET, baseTimeline } from "./_helpers";

// Directional slide with a 2% overshoot. Direction follows the logo's
// dominant axis: horizontal logos slide horizontally, tall logos rise.
export const slideIn: TemplateFn = (ir, logo) => {
  const base = baseTimeline(ir, logo);
  const horizontal = logo.aspect >= 1.4;
  const distance = horizontal ? 180 : 120;
  const fromX = horizontal ? -distance : 0;
  const fromY = horizontal ? 0 : distance;
  const overX = horizontal ? 8 : 0;
  const overY = horizontal ? 0 : -6;
  return {
    ...base,
    tracks: [{
      target: ROOT_TARGET,
      easing: "easeOutExpo",
      delay: 0,
      keyframes: [
        { t: 0.00, opacity: 0, x: fromX, y: fromY,  scale: 0.96, filter: "blur(4px)" },
        { t: 0.70, opacity: 1, x: overX, y: overY,  scale: 1.01, filter: "blur(0px)" },
        { t: 1.00, opacity: 1, x: 0,     y: 0,      scale: 1 },
      ],
    }],
  };
};
